import { Accept } from 'react-dropzone'

export const ACCEPTED_FILE_TYPES: Accept = {
  'image/png': ['.png'],
  'image/jpeg': ['.jpeg', '.jpg'],
  'image/webp': ['.webp'],
  'image/bmp': ['.bmp'],
  'image/gif': ['.gif'],
  'image/x-nikon-nef': ['.nef'],
  'image/avif': ['.avif'],
  'image/tiff': ['.tiff', '.tif'],
  'image/heic': ['.heic'],
  'image/heif': ['.heif'],

  'video/x-matroska': ['.mkv'],
  'video/3gpp2': ['.3g2'],
  'video/3gpp': ['.3gp'],
  'video/ogg': ['.ogv'],
  'video/mpeg': ['.mpeg'],
  'video/x-msvideo': ['.avi'],
  'video/mp4': ['.mp4'],
  'video/webm': ['.webm'],
  'video/x-m4v': ['.m4v'],
  'video/quicktime': ['.mov', '.qt'],
}
